export default "__VITE_ASSET__0ba3dcff__"